import { AUTHENTICATION_STORAGE_NAME } from '@packages/domain/constants/storage';
import type { RootState } from 'reducers/types';
import {
  getAccessToken,
  getExpiresIn,
  getTokenType,
} from 'selectors/entities/authentication/authentication';
import { isImpersonatingUser } from 'selectors/ui/ui';
import { sessionStorage } from 'utils/storage';

export const loadStateFromSessionStorage = () => {
  try {
    const serializedAccessToken = sessionStorage.getItem(
      AUTHENTICATION_STORAGE_NAME,
    );

    if (serializedAccessToken === null) {
      return undefined;
    }

    const { impersonation = false, ...accessTokenDetails } = JSON.parse(
      serializedAccessToken,
    );
    return {
      entities: { authentication: { ...accessTokenDetails } },
      ui: { isImpersonatingUser: impersonation },
    };
  } catch (_err) {
    return undefined;
  }
};

export const saveStateToSessionStorage = (state: RootState) => {
  try {
    const serializableState = {
      accessToken: getAccessToken(state),
      expiresIn: getExpiresIn(state),
      tokenType: getTokenType(state),
      impersonation: isImpersonatingUser(state) || false,
    };

    sessionStorage.setItem(
      AUTHENTICATION_STORAGE_NAME,
      JSON.stringify(serializableState),
    );
  } catch (_e) {
    // do nothing
  }
};
